import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const ArrowCornerTopLeft = ({
	size,
	...props
}: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		{...props}
		xmlns="http://www.w3.org/2000/svg"
	>
		<path d="M19 26H16C13.243 26 11 23.757 11 21V3.22688L18.3364 9.74662C18.513 9.90375 18.745 10 19 10C19.5522 10 20 9.55225 20 9C20 8.70275 19.8695 8.4365 19.6636 8.25338L10.6628 0.252625C10.4862 0.096 10.2546 0 10 0C9.74537 0 9.51375 0.095875 9.33725 0.252625L0.336375 8.25338C0.1305 8.4365 0 8.70275 0 9C0 9.55225 0.44775 10 1 10C1.255 10 1.487 9.90375 1.66363 9.74662L9 3.22688V21C9 24.8599 12.1401 28 16 28H19C19.5522 28 20 27.5522 20 27C20 26.4478 19.5522 26 19 26Z" />
	</svg>
);

export default ArrowCornerTopLeft;
